import { BAZA_INN } from '@/constants'
import { getField } from 'vuex-map-fields'

export const getters = {
  getField,
  systemSellers: state => state.systemSellers,
  bazaSystemSellers: state => state.systemSellers.filter(s => s.organization.INN === BAZA_INN),
  allSystemSellersWarehouses: state => state.systemSellers.flatMap(seller => seller.organization.warehouse_addresses),
}
